<div class="HeadStrip">
  <div class="container">
    <div class="row">
      <div class="col-md-2">
        <div class="Selectnumber">
          <div class="Sub">
            <a routerLink="../job-title"><i class="fa fa-caret-left" aria-hidden="true"></i>Back</a>
          </div>
          02
        </div>
        <!--  Numbering  -->
      </div>
      <div class="col-md-10">
        <div class="WebAppHedding">Aptitude Games</div>
        <div class="WebAppSubHedding">
          Select aptitude games from the list
        </div>
      </div>
    </div>
    <!--  row  -->
  </div>
  <!--  container  -->
</div>
<!--  HeadStrip -->

<!--  Start Section  -->

<section>
  <div class="container WebAppC">
    <div class="row">
      <div class="col-md-4">
        <span class="CompetencyIco"></span>
      </div>
      <div class="col-md-8">
        <div class="row box-grid">
          <div class="col-md-3 BoxP" style="margin-bottom: 10px;" *ngFor="let aptitude of aptitudeData; let i= index">
            <div [ngClass]="setActive(aptitude.gameId._id)" class="WebAppBox" (click)="
                organizationalDNASelected(aptitude.gameId._id, aptitude.order)
              ">
              <h2>{{ aptitude.gameId.name }}</h2>
            </div>
          </div>
        </div>
        <!--  row  -->
        <div class="WebAppBut">
          <button type="button" class="new-btn" (click)="saveCompetencyDetail()">
            Next
          </button>
        </div>
      </div>
    </div>
    <!-- row  -->
  </div>
</section>

<!--  End Section  -->
